module.exports = __webpack_public_path__ + "assets/a73b8add3402aec7974dee3610ac49a9.png";